import { render, staticRenderFns } from "./CssGroup.vue?vue&type=template&id=315c45b0"
import script from "./CssGroup.vue?vue&type=script&lang=js"
export * from "./CssGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports